import React, { ElementType, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { AppFC } from 'types'

export const TagsText = {
  AI: 'AI',
  FREE: 'Free',
}

const TAG_TRANSLATION_KEY: Record<string, string> = {
  [TagsText.AI]: 'tools.tags.ai',
  [TagsText.FREE]: 'tools.tags.free',
}

interface IAppTagsProps {
  tagText: string
  size?: 'small' | 'base' | 'large'
  textSize?: 'small' | 'normal' | 'large'
  Icon?: ElementType
}
export const AppTags: AppFC<IAppTagsProps> = ({
  children,
  tagText,
  size = 'small',
  className,
  textSize = 'small',
  Icon,
}) => {
  const { t } = useTranslation()
  const translationKey = TAG_TRANSLATION_KEY[tagText]
  const localizedTagText = translationKey ? t(translationKey, { defaultValue: tagText }) : tagText
  const backgroundColor = useMemo((): string => {
    return {
      [TagsText.AI]: 'bg-blue',
      [TagsText.FREE]: 'bg-blue-darkest1x',
    }[tagText]
  }, [tagText])

  const textColor = useMemo(() => {
    return {
      [TagsText.AI]: 'text-white',
      [TagsText.FREE]: 'text-white',
    }[tagText]
  }, [tagText])

  const sizeStyles = useMemo(() => {
    return {
      small: 'py-[3px] px-[8px]',
      base: 'py-[4px] px-5',
      large: 'py-[6px] px-5',
    }[size]
  }, [size])

  const textStyles = useMemo(() => {
    return {
      small: 'text-[10px] leading-[18px]',
      normal: 'text-base',
      large: 'text-lg',
    }[textSize]
  }, [textSize])

  return (
    <span
      className={`${backgroundColor} ${sizeStyles} rounded-md ${
        className ? className : 'text-center'
      } `}
    >
      <span className="flex gap-x-[6px] items-center">
        {Icon && <Icon />}
        <span className={`${textColor}  font-[650] ${textStyles} `}>
          {translationKey ? localizedTagText : children}
        </span>
      </span>
    </span>
  )
}
